module.exports = __webpack_public_path__ + "static/media/avatar.6f2bab19.png";